export const SET_BREADCRUMB= 'SET_BREADCRUMB'
export const SET_USER_INFO= 'SET_USER_INFO'
export const CLEAR_USER_INFO= 'CLEAR_USER_INFO'
export const SET_ROUTER='SET_ROUTER'
export const SET_THEME='SET_THEME'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js